<style src="./FormDataInput.scss" lang="scss" scoped></style>
<template>
  <form @submit.prevent="submitForm" class="row">
    <textbox
      class="col-12"
      :autofocus="true"
      label="Nome do cliente"
      placeholder="Ambiente Municipal de São Pedro do Norte"
      v-model="form.name" />

    <textbox
      class="col-12"
      label="Nome curto do cliente"
      placeholder="AM de São Pedro do Norte"
      v-model="form.shortName" />

    <textbox
      class="col-12"
      label="Código externo"
      placeholder="22985"
      v-model="form.externalCode" />

    <div class="commands col-12">
      <button-submit
        class="col-5"
        label="Salvar Cliente"
        :state="commands.submitState"
        :icon-save="commands.saveIcon"/>

      <button
        class="btn-ghost col-5 cancel-button"
        type="button"
        @click="closePanel">
        <icon-close />
        Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import { Textbox, ButtonSubmit } from '@/components/primitives'
import { IconSave, IconClose } from '@/components/primitives/icons'
import NewClient from '@/brain/record/client/AddNewClient'

export default {
  name: 'FormDataInput',
  components: {
    Textbox,
    ButtonSubmit,
    IconSave,
    IconClose
  },
  data () {
    return {
      form: {
        name: '',
        shortName: '',
        externalCode: ''
      },
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      }
    }
  },
  methods: {
    submitForm () {
      this.commands.submitState = 'WAIT'
      NewClient(this.form)
        .then((response) => {
          this.$emit('refresh-list')
          this.clearForm()
          this.commands.submitState = 'REPOSE'
        })
    },
    clearForm () {
      this.form.name = ''
      this.form.shortName = ''
      this.form.externalCode = ''
    },
    closePanel () {
      this.$parent.$emit('close', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/cmed/components/new-cmed/form-data-input/FormDataInput.vue